<template>

  <div class="row">
    <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis">
            Coût moyen de passage portuaire des navires
          </span>
          <h4 class="fw-black mb-12 lh-1">120 000</h4>
          <!-- <span class="fw-bold text-success text-badge d-inline-block">
            5.5%
            <i class="flaticon-up-arrow fs-11 lh-1 position-relative top-1"></i>
          </span> -->
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li class="text-muted position-relative fw-medium">
              Maxinum: <span class="text-black fw-bold">150 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              moyenne: <span class="text-black fw-bold">120 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              Mininum: <span class="text-black fw-bold">80 000</span>
            </li>
          </ul>
          <div id="expectedEraningsChart" class="chart">
            <apexchart type="donut" height="180" :options="expectedEraningsChart" :series="expected"></apexchart>
          </div>
        </div>
      </div>
    </div>
     <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis">
            Coût de revient des marchandises essentielles
          </span>
          <h4 class="fw-black mb-12 lh-1">220 000</h4>
          <!-- <span class="fw-bold text-success text-badge d-inline-block">
            5.5%
            <i class="flaticon-up-arrow fs-11 lh-1 position-relative top-1"></i>
          </span> -->
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li class="text-muted position-relative fw-medium">
              Maxinum - <span class="text-black fw-bold">265 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              moyenne - <span class="text-black fw-bold">220 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              Mininum - <span class="text-black fw-bold">100 000</span>
            </li>
          </ul>
          <div id="expectedEraningsChart" class="chart">
            <apexchart type="donut" height="180" :options="expectedEraningsChart2" :series="expected"></apexchart>
          </div>
        </div>
      </div>
    </div>
     <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-6">
      <div class="card mb-25 border-0 rounded-0 bg-white expected-earnings-box">
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <span class="d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis">
            Coût moyen de passage portuaire
          </span>
          <h4 class="fw-black mb-12 lh-1">150 000</h4>
          <!-- <span class="fw-bold text-success text-badge d-inline-block">
            5.5%
            <i class="flaticon-up-arrow fs-11 lh-1 position-relative top-1"></i>
          </span> -->
          <ul class="list ps-0 mb-0 list-unstyled mt-15">
            <li class="text-muted position-relative fw-medium">
              Maxinum - <span class="text-black fw-bold">165 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              moyenne - <span class="text-black fw-bold">150 000</span>
            </li>
            <li class="text-muted position-relative fw-medium">
              Mininum - <span class="text-black fw-bold">100 000</span>
            </li>
          </ul>
          <div id="expectedEraningsChart" class="chart">
            <apexchart type="donut" height="180" :options="expectedEraningsChart1" :series="expected"></apexchart>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="col-xl-6 col-lg-6 col-xxxl-6 col-sm-6">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-xxxl-6 col-sm-6">
          <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
            <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
              <div class="d-flex align-items-center">
                <div class="icon position-relative rounded-circle text-center text-primary"><i
                    class="flaticon-sterile-box"></i></div>
                <div class="title ms-15"><span
                    class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">ORDERS</span>
                  <h4 class="fw-black mb-8 lh-1">15,209</h4><span
                    class="fw-medium text-dark-emphasis">13,456</span><span
                    class="fw-bold text-success ms-11 text-success">5.5% <i
                      class="flaticon-up-arrow fs-12 lh-1 position-relative top-1"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-xxxl-6 col-sm-6">
          <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
            <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
              <div class="d-flex align-items-center">
                <div class="icon position-relative rounded-circle text-center text-danger"><i
                    class="flaticon-trolley-cart"></i></div>
                <div class="title ms-15"><span
                    class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">ITEMS
                    SOLD</span>
                  <h4 class="fw-black mb-8 lh-1">1,204</h4><span class="fw-medium text-dark-emphasis">1,103</span><span
                    class="fw-bold text-success ms-11 text-success">2.5% <i
                      class="flaticon-up-arrow fs-12 lh-1 position-relative top-1"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-xxxl-6 col-sm-6">
          <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
            <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
              <div class="d-flex align-items-center">
                <div class="icon position-relative rounded-circle text-center text-info"><i class="flaticon-card"></i>
                </div>
                <div class="title ms-15"><span
                    class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">REFUNDS</span>
                  <h4 class="fw-black mb-8 lh-1">
                    <ccc title="$105" class="ccc--converted"
                      style="font-size: inherit; display: inline; color: inherit;">
                      €89.86</ccc>
                  </h4><span class="fw-medium text-dark-emphasis">
                    <ccc title="$560" class="ccc--converted"
                      style="font-size: inherit; display: inline; color: inherit;">
                      €479.25</ccc>
                  </span><span class="fw-bold text-success ms-11 text-danger">1.5% <i
                      class="flaticon-down-arrow fs-12 lh-1 position-relative top-1"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-xxxl-6 col-sm-6">
          <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
            <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
              <div class="d-flex align-items-center">
                <div class="icon position-relative rounded-circle text-center text-success"><i
                    class="flaticon-sugar-cubes"></i></div>
                <div class="title ms-15"><span
                    class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">GROSS
                    SALE</span>
                  <h4 class="fw-black mb-8 lh-1">
                    <ccc title="$12,345" class="ccc--converted"
                      style="font-size: inherit; display: inline; color: inherit;">€10564.85</ccc>
                  </h4><span class="fw-medium text-dark-emphasis">
                    <ccc title="$10,320" class="ccc--converted"
                      style="font-size: inherit; display: inline; color: inherit;">€8831.86</ccc>
                  </span><span class="fw-bold text-success ms-11 text-success">11.5% <i
                      class="flaticon-up-arrow fs-12 lh-1 position-relative top-1"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
  <div class="card mb-25 border-0 rounded-0 bg-white sales-pos-location-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between">
        <div class="title">
          <span class="fw-medium text-muted fs-13 d-block mb-5 text-uppercase">
            Navire opérant sans licence et suspectés de non-conformité
          </span>
        </div>
        <div class="card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5">
          <span class="fw-medium text-muted me-8">Sélectionner</span>
          <select class="form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium">
            <option value="1" class="fw-medium">Par semaine</option>
            <option value="2" class="fw-medium">Ce mois-ci</option>
            <option value="3" class="fw-medium" selected>Cette année</option>
          </select>
        </div>
      </div>
      <div id="weeklySalesChart" class="chart">
        <apexchart type="line" height="375" :options="weeklySalesChart" :series="sales"></apexchart>
      </div>
    </div>
  </div>

</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "WeeklySales",
  setup() {
    const sales = ref([
      {
        name: "",
        data: [80, 110, 50, 100, 70, 100, 140, 90, 120, 160, 130],
      },
    ]);

    const weeklySalesChart = ref({
  chart: {
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  colors: ["#070376FF", "#02198AFF"],
  legend: {
    position: "top",
    fontSize: "14px",
    fontWeight: 500,
    horizontalAlign: "center",
    fontFamily: "Red Hat Display, sans-serif",
    labels: {
      colors: "#8E8DA1",
    },
    markers: {
      offsetY: -1,
      offsetX: -4,
      height: 15,
      width: 15,
    },
    itemMargin: {
      horizontal: 10,
    },
  },
  grid: {
    show: true,
    strokeDashArray: 5,
    borderColor: "#d9e9ef",
  },
  tooltip: {
    style: {
      fontSize: "14px",
      fontFamily: "Red Hat Display, sans-serif",
    },
    y: {
      formatter: function (val: string) {
        return + val + " Navire(s)";
      },
    },
  },
  xaxis: {
    categories: ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov"],
    labels: {
      show: true,
      style: {
        fontFamily: "Red Hat Display, sans-serif",
        colors: "#9C9AB6",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    axisTicks: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    tooltip: {
      style: {
        fontFamily: "Red Hat Display, sans-serif",
        colors: "#2b2a3f",
        fontSize: "14px",
      },
    },
  },
  yaxis: {
    show: true,
    labels: {
      style: {
        fontFamily: "Red Hat Display, sans-serif",
        colors: ["#9C9AB6"],
        fontSize: "14px",
        fontWeight: 500,
      },
    },
  },
});

const expected = ref([50, 35, 45]);

const expectedEraningsChart = ref({
  chart: {
    height: 150,
    type: "donut",
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#080072FF", "#107A02FF", "#0777A0FF"],
  legend: {
    show: false,
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "Red Hat Display, sans-serif",
    labels: {
      colors: "#9C9AB6",
    },
    markers: {
      offsetX: -2,
      offsetY: 1,
    },
  },
  stroke: {
    width: 0,
  },
  tooltip: {
    enabled: false,
    style: {
      fontSize: "14px",
      fontFamily: "Red Hat Display, sans-serif",
    },
  },
});

const expectedEraningsChart1 = ref({
  chart: {
    height: 150,
    type: "donut",
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#BD0000FF", "#D97A05FF", "#6FD3F7"],
  legend: {
    show: false,
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "Red Hat Display, sans-serif",
    labels: {
      colors: "#9C9AB6",
    },
    markers: {
      offsetX: -2,
      offsetY: 1,
    },
  },
  stroke: {
    width: 0,
  },
  tooltip: {
    enabled: false,
    style: {
      fontSize: "14px",
      fontFamily: "Red Hat Display, sans-serif",
    },
  },
});

const expectedEraningsChart2 = ref({
  chart: {
    height: 150,
    type: "donut",
  },
  dataLabels: {
    enabled: false,
  },
  colors: ["#88006DFF", "#D4F900FF", "#04340EFF"],
  legend: {
    show: false,
    fontWeight: 500,
    fontSize: "14px",
    fontFamily: "Red Hat Display, sans-serif",
    labels: {
      colors: "#9C9AB6",
    },
    markers: {
      offsetX: -2,
      offsetY: 1,
    },
  },
  stroke: {
    width: 0,
  },
  tooltip: {
    enabled: false,
    style: {
      fontSize: "14px",
      fontFamily: "Red Hat Display, sans-serif",
    },
  },
});

    return {
      sales,
      weeklySalesChart,
      expected,
      expectedEraningsChart,
      expectedEraningsChart1,
      expectedEraningsChart2,
    };
  },
});
</script>